import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import {
  loadForgotPasscodeVerify,
  loadForgotPasscodeVerifySuccess,
  loadForgotPasscodeVerifyFailure,
  clearForgotPasscodeVerifyFailure,
  clearForgotPasscodeVerifySuccess
} from '../actions/forgot-passcode-verify.actions';
import { IForgotPasscodeVerifyRequest, IForgotPasscodeVerifyResponse } from '../models/forgot-passcode-verify.model';

export const forgotPasswordFeatureKey = 'forgotPasswordVerify';

export interface ForgotPasscodeVerifyState {
  isLoading: boolean;
  forgotPasscodeVerifyRequest: IForgotPasscodeVerifyRequest;
  forgotPasscodeVerifyResponse: IForgotPasscodeVerifyResponse;
  IForgotPasscodeVerifyFailure: IGenericError<ErrorResponse>;
}

export const initialState: ForgotPasscodeVerifyState = {
  forgotPasscodeVerifyRequest: undefined,
  forgotPasscodeVerifyResponse: undefined,
  IForgotPasscodeVerifyFailure: undefined,
  isLoading: false
};

export const reducer = createReducer(
  initialState,

  on(loadForgotPasscodeVerify, (state, action) => ({
    ...state,
    forgotPasscodeVerifyRequest: action.request,
    isLoading: true
  })),

  on(loadForgotPasscodeVerifySuccess, (state, action) => ({
    ...state,
    forgotPasscodeVerifyResponse: action.response,
    isLoading: false
  })),

  on(loadForgotPasscodeVerifyFailure, (state, action) => ({
    ...state,
    IForgotPasscodeVerifyFailure: action.error,
    isLoading: false
  })),

  on(clearForgotPasscodeVerifyFailure, (state, action) => ({
    ...state,
    IForgotPasscodeVerifyFailure: undefined
  })),

  on(clearForgotPasscodeVerifySuccess, (state, action) => ({
    ...state,
    forgotPasscodeVerifyResponse: undefined
  }))
);

export const getForgotPasswordsVerifyRequest = (state: ForgotPasscodeVerifyState) => state.forgotPasscodeVerifyRequest;
export const getForgotPasswordsVerifyResponse = (state: ForgotPasscodeVerifyState) => state.forgotPasscodeVerifyResponse;
export const getForgotPasswordsVerifyFailure = (state: ForgotPasscodeVerifyState) => state.IForgotPasscodeVerifyFailure;
export const getForgotPasswordsVerifyIsLoading = (state: ForgotPasscodeVerifyState) => state.isLoading;
